import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IProduct, IOrderBumpForm, IOrderBumpFormItem, IOrderBumpProduct } from 'types/interfaces';

export interface IOrderBumpFormState extends IOrderBumpForm<IOrderBumpProduct | IOrderBumpFormItem> {
  isLoading?: boolean;
  mainProduct?: IOrderBumpProduct;
  orderBumpsProducts?: IOrderBumpProduct[];
  clearCacheContentIds: number[];
  removedItemsContentIds: number[];
}

export const initialState: IOrderBumpFormState = {
  isLoading: false,
  orderBumpsProducts: [],
  bumpItemsLimit: 1,
  removedItemsContentIds: [],
  clearCacheContentIds: []
};

const orderBumpFormSlice = createSlice({
  name: 'Order Bump Form',
  initialState,
  reducers: {
    reset(state) {
      state = initialState;
      return state;
    },
    setState(state, action: PayloadAction<IOrderBumpFormState>) {
      state = action.payload;
      return state;
    },
    setMainProduct(state, action: PayloadAction<IProduct>) {
      state.mainProduct = action.payload;
      return state;
    },
    setBumpItems(state, action: PayloadAction<IOrderBumpProduct[]>) {
      state.orderBumpsProducts = action.payload;
      return state;
    },
    setBumpItemsLimit(state, action: PayloadAction<number>) {
      state.bumpItemsLimit = action.payload;
      return state;
    },
    addRemovedItems(state, action: PayloadAction<number[]>) {
      state.removedItemsContentIds = [...new Set([...state.removedItemsContentIds, ...action.payload])];
      return state;
    },
    setIsLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
      return state;
    },
    addContentIdForClearCache(state, action: PayloadAction<number>) {
      state.clearCacheContentIds = [...new Set([...state.clearCacheContentIds, action.payload])];
      return state;
    }
  }
});

export const orderBumpFormActions = orderBumpFormSlice.actions;
export default orderBumpFormSlice.reducer;
